var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIGeek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1051.49,
    height: 344.24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 321.48,
    y1: -24.54,
    x2: -11.52,
    y2: 302.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 346.67,
    y1: 1.12,
    x2: 13.67,
    y2: 328.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 346.53,
    y1: 0.97,
    x2: 13.53,
    y2: 327.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 293.6,
    y1: -52.93,
    x2: -39.4,
    y2: 274.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 335.18,
    y1: -10.58,
    x2: 2.18,
    y2: 316.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 343.86,
    y1: -1.75,
    x2: 10.86,
    y2: 325.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4ebd96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48b497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 367.52,
    y1: 22.35,
    x2: 34.52,
    y2: 349.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 312.22,
    y1: -33.97,
    x2: -20.78,
    y2: 293.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 352.79,
    y1: 7.35,
    x2: 19.79,
    y2: 334.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 373.62,
    y1: 28.56,
    x2: 40.62,
    y2: 355.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4e4e}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.21 144.36h-31.52v-26.9h31.52Zm0 99.1h-31.52v-78.79h31.52ZM548 144.36H437.75c0-7.14.35-7.58 1.08-10.53a18.37 18.37 0 0 1 8.17-11.69q7.46-4.68 22.22-4.68h47.28q14.76 0 22.15 4.61a18.46 18.46 0 0 1 8.19 11.7c.8 3.12 1.16 3.58 1.16 10.59Zm0 67.58q0 10.71-1.11 15.15a18.38 18.38 0 0 1-8.18 11.69q-7.46 4.68-22.22 4.68h-47.25q-14.78 0-22.16-4.62a18.44 18.44 0 0 1-8.18-11.69q-1.17-4.68-1.17-15.21v-47.27h31.51v47.27h47.28v-15.76H485v-31.51h31.52q14.76 0 22.15 4.62a18.41 18.41 0 0 1 8.19 11.71q1.17 4.68 1.17 15.2ZM715.85 144.36h-110.3v-26.9h110.3Zm0 99.1h-110.3v-78.79h78.79v31.51h-47.28v15.76h78.79ZM883.67 144.36H773.36v-26.9h110.31Zm0 99.1H773.36v-78.79h78.79v31.51h-47.27v15.76h78.79ZM1051.49 243.46h-39.4l-39.39-51.22v51.22h-31.52v-78.79h31.52l39.39-47.21h39.4l-51.22 63Zm-78.79-99.1h-31.52v-26.9h31.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient)"
    },
    d: "M330.25 0h11.72v11.72h-11.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-2)"
    },
    d: "M301.9 20.33h24.68v24.68H301.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-3)"
    },
    d: "M173.58 35.79h29.39v29.39h-29.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-4)"
    },
    d: "M240.87 44.69h37.68v37.68h-37.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-5)"
    },
    d: "M199.24 76.45h19.2v19.23h-19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-6)"
    },
    d: "M280.83 88.45h19.21v19.21h-19.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-7)"
    },
    d: "M220.68 40.52h15.55v15.55h-15.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-8)"
    },
    d: "M230.37 103.09h24.69v24.69h-24.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-9)"
    },
    d: "M262.42 127.77h10.08v10.08h-10.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19 164.58h-122.5c-18.68 0-30.91 10.68-30.91 32.18a37.83 37.83 0 0 0 2.21 12.8c3.68 10.07 12.34 18.81 28.7 18.81 6.88 0 13.35-1.11 20.93-6.88v-15.72h-23.45v-18.26h42.42v42.86c-8.42 12.08-21.9 18.26-40 18.26-29 0-44.22-15.35-49.77-34a62.15 62.15 0 0 1-2.52-17.85c0-27.69 16.31-52.26 52.42-52.26H295v-19.46h-19.5v14.57h-17.09V133h-34.16v-10.6h-20.5V101h-10.32V73.16h-32V48h-41l-73 .59A47.53 47.53 0 0 0 0 96.05v200.7a47.49 47.49 0 0 0 47.46 47.49h30.76V164.67h23.26v179.57h146.69A47.46 47.46 0 0 0 295 304.71a45.41 45.41 0 0 0 .68-8l-.44-116.1Zm-193.71-20.22H78.22v-23.28h23.26Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIGeek);
export default __webpack_public_path__ + "static/media/iGeek.c80f4e14684d12f64834f9bd2c13da9c.svg";
export { ForwardRef as ReactComponent };